// Draagt een van deze deelname-rijen een bruikbare vragenlijst van het programma?
//
// Een halve rij levert geen link op: zonder onderzoek, vragenlijst én meetmoment
// opent de invulpagina een lege vragenlijst in plaats van te zeggen dat er iets
// mist. Daarom alle drie of niets.
//
// AI-CONTEXT: See docs/features/energiearmoede-arnhem-ketensamenwerking.md

/**
 * @param {Array<object>} [participations] - `undefined` = nog niet geladen
 * @returns {boolean} False betekent ook 'weet ik nog niet' — de aanroeper toont
 *   dan niets, wat veiliger is dan een tabblad dat leeg opent
 */
const hasProgrammeQuestionnaire = (participations) =>
    Array.isArray(participations)
    && participations.some((rij) => rij?.ResearchID && rij?.QuestionnaireID && rij?.MomentID)

export default hasProgrammeQuestionnaire
